import { useRouter } from "next/router";
import { useCallback, useContext } from "react";
import { triggerPriceMatchErrors } from "../../useAnalyticsHooks";
import { PricePromiseContext } from "./index";
import { handleResetState, postFormData } from "./utils";

const useForm = () => {
  const router = useRouter();
  const { stateHandlers, elementStates, serverError, setServerError } = useContext(PricePromiseContext);

  if (!elementStates || !stateHandlers) {
    throw new Error("useForm must be used within a FormProvider");
  }

  const handleChange = useCallback(
    (name, value) => {
      if (serverError) {
        setServerError(null);
      }
      stateHandlers.updateResponses({
        ...handleResetState(elementStates, name),
        [name]: value,
      });
    },
    [serverError, setServerError, stateHandlers, elementStates],
  );

  const addAttachment = useCallback(
    ({ name, file, imagePreviewUrl }) => {
      stateHandlers.addAttachment({ name, file, imagePreviewUrl });
    },
    [stateHandlers],
  );

  const removeAttachment = useCallback(
    ({ name, fileId }) => {
      stateHandlers.removeAttachment({ name, fileId });
    },
    [stateHandlers],
  );

  const setAttachmentError = useCallback(
    ({ name, error }) => {
      stateHandlers.setAttachmentError({ name, error });
      triggerPriceMatchErrors({ [name]: error });
    },
    [stateHandlers],
  );

  const handleFormSubmit = useCallback(
    (_, onComplete) => {
      postFormData({ state: elementStates, router, onComplete, setServerError });
    },
    [elementStates, router, setServerError],
  );

  return {
    state: elementStates,
    handleChange,
    addAttachment,
    removeAttachment,
    setAttachmentError,
    serverError,
    handleFormSubmit,
  };
};

export default useForm;
